import { render, staticRenderFns } from "./recycle_bin.vue?vue&type=template&id=1027465a&scoped=true"
import script from "./recycle_bin.vue?vue&type=script&lang=js"
export * from "./recycle_bin.vue?vue&type=script&lang=js"
import style0 from "./recycle_bin.vue?vue&type=style&index=0&id=1027465a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1027465a",
  null
  
)

export default component.exports